import React, { useEffect, UseEffect } from "react";
import { pagetypeActions } from "../../actions";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";

function PageTypeTree(props) {

    const { getPageTypeTree, pagetypes, page, authentication } = props;
    const { id } = useParams();
    const org_id = Number(id);

    useEffect(() => {
        getPageTypeTree(org_id);
    }, [org_id, page.current_page]);

    const formatTree = pagetypes?.tree?.map((group) => (
        <li>{group.page_group_name}</li>
    ));

    return (
        <>
            The tree: <br />
            <ul>
                {formatTree}
            </ul>
        </>

    )

};

function mapStateToProps(state) {
    const { pagetypes, page, authentication } = state;
    return {
        pagetypes,
        page,
        authentication
    };
}

const actionCreators = {
    getPageTypeTree: pagetypeActions.getPageTypeTree,

};

const connectedPageTypeTree = connect(
    mapStateToProps,
    actionCreators
)(PageTypeTree);
export { connectedPageTypeTree as PageTypeTree };